import axios from "axios";
import { COURSE_SERVICE_URL, getHeaders } from "@/apis/common";

const SHORT_MONTHS = Array.from({ length: 12 }, (x, index) =>
  new Date(0, index)
    .toLocaleDateString("en-US", { month: "short" })
    .toLowerCase(),
);

function isValidMonth(month) {
  return SHORT_MONTHS.includes(month.trim().toLowerCase());
}

export function getNormalsByZip(token, zip) {
  const url = `${COURSE_SERVICE_URL}/private/weather/normals/${zip}`;
  const headers = getHeaders(token);
  const config = {
    headers,
  };

  return axios.get(url, config).then(res => res.data);
}

/**
 * Retrieves a list of zip codes for a given month and multiple temperature ranges.
 * @param {string} month - The lowercase short month, e.g. 'mar', 'dec', 'sep'
 * @param {string} temps - Comma delimited, dash separated, temp range pairs, e.g. 85-92,68-72
 */
export function getNormalsZipsByMonthAndTempRange(token, month, temps) {
  // /private/weather/normals/zips/avg?month=dec&temps=85-92,68-72
  if (!isValidMonth(month)) {
    return Promise.reject(
      "Invalid month, use the short abbreviation, e.g. 'mar', 'dec', 'sep'",
    );
  }

  const url = `${COURSE_SERVICE_URL}/private/weather/normals/zips/avg?month=${month}&temps=${temps}`;
  const headers = getHeaders(token);
  const config = {
    headers,
  };

  return axios.get(url, config).then(res => res.data);
}
